<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import Tooltip from '~/components/ui/Tooltip.vue'

const images = defineModel<string[]>('images')
const currentImage = defineModel<string>('currentImage')

const { t } = useI18n()
</script>

<template>
  <div class="absolute -bottom-12 left-0 flex h-max flex-col items-center rounded-xl bg-(--theme-10) p-3 md:top-0 md:right-[-103px] md:left-auto print:hidden">
    <ul class="flex gap-1 md:flex-col">
      <li
        v-for="(image, i) in images"
        :key="i"
      >
        <Tooltip side="left" :content="t('formWriter.tooltips.chooseImage')">
          <button class="rounded focus-visible:ring" @click="currentImage = image">
            <img
              :src="image"
              class="aspect-video h-full w-18 rounded object-cover md:aspect-auto md:object-contain"
              alt=""
            >
          </button>
        </Tooltip>
      </li>
    </ul>
  </div>
</template>
